import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Inject, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, Track, formControlValueInput, formControlDisabledInput, formControlValueOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/signature/signature';

class FadvSignatureComponent extends mixinFormControl(FadvBaseComponent) {
    constructor(element) {
        super(element);
        this.signatureChanged = new EventEmitter();
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((imageDataUrl) => {
            if (imageDataUrl) {
                this.loadSignature(imageDataUrl);
            }
        });
        this.registerSubscription(this.signatureChanged, ({ image }) => {
            this.reportChange(image);
        });
        this.reportChange(this.saveSignature());
    }
    handleSignatureChange(event) {
        this.signatureChanged.emit(event.detail);
    }
    clearSignature() {
        this.elementRef.nativeElement.clearSignature();
    }
    saveSignature() {
        return this.elementRef.nativeElement.saveSignature();
    }
    loadSignature(imageDataUrl) {
        this.elementRef.nativeElement.loadSignature(imageDataUrl);
    }
}
FadvSignatureComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvSignatureComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvSignatureComponent, selector: "fadv-signature", inputs: { value: "value", disabled: "disabled", prefilledSignature: "prefilledSignature", drawSignature: "drawSignature", readonly: "readonly", disclaimer: "disclaimer", useDefaultDisclaimer: "useDefaultDisclaimer", label: "label", drawOnly: "drawOnly" }, outputs: { valueChange: "valueChange", signatureChanged: "signatureChanged" }, host: { listeners: { "signature-change": "handleSignatureChange($event)" } }, providers: [createFormControlProvider(FadvSignatureComponent)], usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "prefilledSignature", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "drawSignature", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "disclaimer", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "useDefaultDisclaimer", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvSignatureComponent.prototype, "drawOnly", void 0);
__decorate([
    Track()
], FadvSignatureComponent.prototype, "signatureChanged", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-signature',
                    template: '',
                    providers: [createFormControlProvider(FadvSignatureComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { prefilledSignature: [{
                type: Input
            }], drawSignature: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disclaimer: [{
                type: Input
            }], useDefaultDisclaimer: [{
                type: Input
            }], label: [{
                type: Input
            }], drawOnly: [{
                type: Input
            }], signatureChanged: [{
                type: Output
            }], handleSignatureChange: [{
                type: HostListener,
                args: ['signature-change', ['$event']]
            }] } });

class FadvSignatureModule {
}
FadvSignatureModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvSignatureModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureModule, declarations: [FadvSignatureComponent], imports: [FadvCommonModule], exports: [FadvSignatureComponent] });
FadvSignatureModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSignatureModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvSignatureComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvSignatureComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvSignatureComponent, FadvSignatureModule };
